import { ReducersTypes } from '../Constants';


export const setSaveProgress = (data) => ({
  type: ReducersTypes.SETSAVEPROGRESS,
  payload: data,
});

export const removeSaveProgress = () => ({
  type: ReducersTypes.REMOVESAVEPROGRESS,
});

export const startLoadProcess = () => ({
  type: ReducersTypes.LOADINGPENDING,
});

export const stopLoadProcess = () => ({
  type: ReducersTypes.LOADINGDONE,
});

// export const SETCLOCKINDATA = () => ({
//   type: ReducersTypes.SETCLOCKINDATA,
// });